import { useGetSystemTabDataById } from "@features/ax/assetRegistry/systems/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { TooltipProvider } from "@shared/ui/tooltip";
import { Cpu } from "lucide-react";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { AdditionalSystemKPIs } from "./additionalSystemKPIs";
import { AssetConditionAge } from "./assetConditionAge";
import { ComplianceWaterQuality } from "./complianceWaterQuality";
import { ReliabilityMetrics } from "./reliabilityMetrics";
import { SystemHealthSummary } from "./systemSummary";
import { WorkOrderMaintenance } from "./workOrderMaintenance";

interface PerformanceLandingProps {
  systemData?: any;
}

export const PerformanceLanding: React.FC<PerformanceLandingProps> = ({
  systemData,
}) => {
  const { systemId } = useParams();
  const { data: performanceData } = useGetSystemTabDataById(
    Number(systemId),
    "performance"
  );
  useEffect(() => {
    logEvent("performance_tab_viewed");
  }, []);

  return (
    <TooltipProvider>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
            <Cpu className="h-5 w-5 text-indigo-600" />
          </div>
          <div>
            <PageHeader
              title="System Performance Overview"
              subtitle="Comprehensive system health, performance, and operational metrics"
            />
          </div>
        </div>

        {/* System Health & Reliability Summary */}
        <SystemHealthSummary data={performanceData} />

        {/* Additional System KPIs */}
        <AdditionalSystemKPIs data={performanceData} />

        {/* Reliability Metrics */}
        <ReliabilityMetrics data={performanceData} />

        {/* Energy Consumption Section */}
        {/* <EnergyConsumption data={performanceData} /> */}

        {/* Compliance & Water Quality Section */}
        <ComplianceWaterQuality data={performanceData} />

        {/* Asset Condition & Age Profile */}
        <AssetConditionAge data={performanceData} />

        {/* Work Order & Maintenance Overview */}
        <WorkOrderMaintenance data={performanceData} />
      </div>
    </TooltipProvider>
  );
};
